import RatingStat from '@core/RatingStat';
import type { RatingStatProps } from '@core/RatingStat';

import { useCardContext } from './CardContext';

/**
 * RatingStat wrapper component that responds to compact mode.
 * Use this inside CardRatings for ratings that should be smaller in compact mode.
 *
 * @example
 * <CardRatings>
 *   <CardRatingsStat rating={4.9} reviews={1234} />
 * </CardRatings>
 */
const CardRatingsStat = (props: RatingStatProps) => {
  const context = useCardContext();
  const finalSize =
    props.size || (context?.useCompactTypography ? 'meta' : 'label');

  return <RatingStat {...props} size={finalSize} />;
};

export default CardRatingsStat;
